import Vue from 'vue';
import VueI18n from 'vue-i18n';
// mui
import zhLocale from 'element-ui/src/locale/lang/zh-CN';
import enLocale from 'element-ui/src/locale/lang/en';
import jpLocale from 'element-ui/src/locale/lang/ja';
// 自定义
import indexLang from './modules/index/index';
import devLang from './modules/developer/index';
import systemLang from './modules/system/index';
import componentsLang from './components/index';
import otpLang from './modules/transport/otp/index';
import BMSLang from './modules/transport/BMS/index';
import tmsLang from './modules/transport/tms/index';
import lsrmLang from './modules/transport/lsrm/index';

export default {
    initLanguage(userLang) {
        // 用户设置的语言>浏览器的语言>默认语言
        const navLang = navigator.browserLanguage ? navigator.browserLanguage : navigator.language;
        const localLang = (navLang === 'zh-CN' || navLang === 'en-US' || navLang === 'ja-JP') ? navLang : false;
        const lang = userLang || localLang || 'zh-CN';
        Vue.use(VueI18n);
        return new VueI18n({
            locale: lang,
            messages: {
                'zh-CN': Object.assign({}, { siteIndex: indexLang.zh }, { otp: otpLang.zh }, { BMSLang: BMSLang.zh }, { tms: tmsLang.zh }, { lsrmLang: lsrmLang.zh }, { developer: devLang.zh },
                    { system: systemLang.zh }, { components: componentsLang.zh }, zhLocale),
                'en-US': Object.assign({}, { siteIndex: indexLang.en }, { otp: otpLang.en }, { BMSLang: BMSLang.en }, { tms: tmsLang.en }, { lsrmLang: lsrmLang.zh }, { developer: devLang.en },
                    { system: systemLang.en }, { components: componentsLang.en }, enLocale),
                'ja-JP': Object.assign({}, { siteIndex: indexLang.ja }, { otp: otpLang.js }, { BMSLang: BMSLang.js }, { tms: tmsLang.js }, { lsrmLang: lsrmLang.zh }, { developer: devLang.ja },
                    { system: systemLang.ja }, { components: componentsLang.ja }, jpLocale)
            }
        });
    }
};
